export const leagues = [
  {
    slug: "nba",
    name: "NBA",
    fullName: "NBA 美国职业篮球联赛",
    region: "北美洲",
    intro: "汇集世界顶级球星的职业篮球联赛，常规赛与季后赛赛程密集，攻防节奏快、观赏性极强，是篮球直播平台的核心内容板块。",
    highlights: ["常规赛 82 场", "季后赛七战四胜", "全明星周末"],
    banner: "https://readdy.ai/api/search-image?query=professional%20basketball%20arena%20interior%20with%20glowing%20spotlights%20and%20dark%20navy%20court%2C%20dramatic%20sports%20photography%2C%20empty%20stands%20blurred%2C%20cinematic%20moody%20lighting%2C%20high%20contrast&width=1200&height=600&seq=bb-league-nba-01&orientation=landscape",
    accent: "#C8102E",
  },
  {
    slug: "cba",
    name: "CBA",
    fullName: "CBA 中国男子篮球职业联赛",
    region: "中国",
    intro: "中国最高水平的男子篮球职业联赛，本土球员与强力外援同场竞技，赛程覆盖全国多座城市主场，是中文篮球观众关注度最高的联赛之一。",
    highlights: ["常规赛 46 轮", "南北分区对抗", "全明星周末"],
    banner: "https://readdy.ai/api/search-image?query=modern%20chinese%20basketball%20court%20with%20orange%20accents%20and%20bright%20hanging%20lights%2C%20clean%20sports%20arena%20photography%2C%20wide%20angle%2C%20vibrant%20and%20professional&width=1200&height=600&seq=bb-league-cba-02&orientation=landscape",
    accent: "#E4572E",
  },
  {
    slug: "euroleague",
    name: "欧洲篮球",
    fullName: "欧洲篮球联赛 EuroLeague",
    region: "欧洲",
    intro: "欧洲俱乐部篮球的顶级舞台，强调团队配合与战术执行力，比赛节奏稳健、身体对抗激烈，是技术流球迷的必看赛事。",
    highlights: ["常规赛双循环", "四强赛制", "战术素养极高"],
    banner: "https://readdy.ai/api/search-image?query=elegant%20european%20indoor%20basketball%20arena%20with%20warm%20amber%20stage%20lighting%20and%20polished%20hardwood%20floor%2C%20editorial%20sports%20photography%2C%20deep%20shadows%2C%20refined%20atmosphere&width=1200&height=600&seq=bb-league-euro-03&orientation=landscape",
    accent: "#1F6F8B",
  },
  {
    slug: "wnba",
    name: "女子篮球",
    fullName: "女子篮球职业联赛 WNBA",
    region: "北美洲",
    intro: "世界顶级女子篮球联赛，投篮精准、转移球流畅，近年热度持续攀升，为观众呈现极具观赏性的团队篮球。",
    highlights: ["常规赛 40 场", "季后赛淘汰制", "新星辈出"],
    banner: "https://readdy.ai/api/search-image?query=bright%20clean%20modern%20basketball%20gymnasium%20with%20teal%20and%20white%20tones%20and%20daylight%20through%20high%20windows%2C%20fresh%20energetic%20sports%20photography%2C%20wide%20composition&width=1200&height=600&seq=bb-league-wnba-04&orientation=landscape",
    accent: "#0F7B6C",
  },
];

export default leagues;